module.exports = __webpack_public_path__ + "static/media/pricing-icon-shipping.4af01082.svg";